module.exports = __webpack_public_path__ + "static/img/antenatal1.5b347c84.jpg";